var map = {
	"./applied-ict": [
		15352,
		5352
	],
	"./applied-ict.tsx": [
		15352,
		5352
	],
	"./applied-science": [
		45400,
		5400
	],
	"./applied-science.tsx": [
		45400,
		5400
	],
	"./art": [
		43930,
		3930
	],
	"./art.tsx": [
		43930,
		3930
	],
	"./biology": [
		34108,
		4108
	],
	"./biology.tsx": [
		34108,
		4108
	],
	"./buddhism": [
		12481,
		2481
	],
	"./buddhism.tsx": [
		12481,
		2481
	],
	"./built-environment": [
		65266,
		5266
	],
	"./built-environment.tsx": [
		65266,
		5266
	],
	"./business": [
		56083,
		6083
	],
	"./business.tsx": [
		56083,
		6083
	],
	"./chemistry": [
		53157,
		3157
	],
	"./chemistry.tsx": [
		53157,
		3157
	],
	"./childrens-care-play-learning-and-development": [
		23359,
		3359
	],
	"./childrens-care-play-learning-and-development.tsx": [
		23359,
		3359
	],
	"./christianity": [
		76996,
		6996
	],
	"./christianity.tsx": [
		76996,
		6996
	],
	"./computer-sci": [
		81846,
		1846
	],
	"./computer-sci.tsx": [
		81846,
		1846
	],
	"./construction": [
		51788,
		1788
	],
	"./construction.tsx": [
		51788,
		1788
	],
	"./creative-media-and-performing-arts": [
		72256,
		2256
	],
	"./creative-media-and-performing-arts.tsx": [
		72256,
		2256
	],
	"./criminology": [
		63095,
		3095
	],
	"./criminology.tsx": [
		63095,
		3095
	],
	"./design-tech": [
		33668,
		3668
	],
	"./design-tech.tsx": [
		33668,
		3668
	],
	"./digital-tech": [
		62359,
		2359
	],
	"./digital-tech.tsx": [
		62359,
		2359
	],
	"./drama": [
		13873,
		3873
	],
	"./drama.tsx": [
		13873,
		3873
	],
	"./economics": [
		6544,
		6544
	],
	"./economics.tsx": [
		6544,
		6544
	],
	"./electronics": [
		13629,
		3629
	],
	"./electronics.tsx": [
		13629,
		3629
	],
	"./engineering": [
		42525,
		2525
	],
	"./engineering.tsx": [
		42525,
		2525
	],
	"./english-language": [
		36890,
		6890
	],
	"./english-language-and-literature": [
		1602,
		1602
	],
	"./english-language-and-literature.tsx": [
		1602,
		1602
	],
	"./english-language.tsx": [
		36890,
		6890
	],
	"./english-literature": [
		91738,
		1738
	],
	"./english-literature.tsx": [
		91738,
		1738
	],
	"./essential-communication-skills": [
		20315,
		315
	],
	"./essential-communication-skills.tsx": [
		20315,
		315
	],
	"./essential-digital-literacy-skills": [
		20125,
		125
	],
	"./essential-digital-literacy-skills.tsx": [
		20125,
		125
	],
	"./essential-employability-of-number-skills": [
		73085,
		3085
	],
	"./essential-employability-of-number-skills.tsx": [
		73085,
		3085
	],
	"./essential-employability-skills": [
		58544,
		8544
	],
	"./essential-employability-skills.tsx": [
		58544,
		8544
	],
	"./essential-skills-for-work-and-life": [
		63953,
		3953
	],
	"./essential-skills-for-work-and-life.tsx": [
		63953,
		3953
	],
	"./event-op": [
		15613,
		5613
	],
	"./event-op.tsx": [
		15613,
		5613
	],
	"./extend project": [
		29052,
		9052
	],
	"./extend project.tsx": [
		29052,
		9052
	],
	"./film": [
		69095,
		9095
	],
	"./film.tsx": [
		69095,
		9095
	],
	"./food": [
		60733,
		733
	],
	"./food-and-nutrition": [
		29890,
		9890
	],
	"./food-and-nutrition.tsx": [
		29890,
		9890
	],
	"./food-science-and-nutrition": [
		66245,
		6245
	],
	"./food-science-and-nutrition.tsx": [
		66245,
		6245
	],
	"./food.tsx": [
		60733,
		733
	],
	"./french": [
		69637,
		9637
	],
	"./french.tsx": [
		69637,
		9637
	],
	"./geography": [
		47499,
		7499
	],
	"./geography.tsx": [
		47499,
		7499
	],
	"./geology": [
		1994,
		1994
	],
	"./geology.tsx": [
		1994,
		1994
	],
	"./german": [
		97875,
		7875
	],
	"./german.tsx": [
		97875,
		7875
	],
	"./global-business-communication": [
		46436,
		6436
	],
	"./global-business-communication.tsx": [
		46436,
		6436
	],
	"./government-and-politics": [
		68298,
		8298
	],
	"./government-and-politics.tsx": [
		68298,
		8298
	],
	"./health-and-social-care": [
		43006,
		3006
	],
	"./health-and-social-care.tsx": [
		43006,
		3006
	],
	"./healthy-living-and-fitness": [
		41807,
		1807
	],
	"./healthy-living-and-fitness.tsx": [
		41807,
		1807
	],
	"./hinduism": [
		3337,
		3337
	],
	"./hinduism.tsx": [
		3337,
		3337
	],
	"./history": [
		34202,
		4202
	],
	"./history.tsx": [
		34202,
		4202
	],
	"./home-economics": [
		89260,
		9260
	],
	"./home-economics.tsx": [
		89260,
		9260
	],
	"./hospitality-and-catering": [
		7083,
		7083
	],
	"./hospitality-and-catering.tsx": [
		7083,
		7083
	],
	"./humanities": [
		74068,
		4068
	],
	"./humanities.tsx": [
		74068,
		4068
	],
	"./ict": [
		29767,
		9767
	],
	"./ict.tsx": [
		29767,
		9767
	],
	"./independent-living": [
		98106,
		8106
	],
	"./independent-living.tsx": [
		98106,
		8106
	],
	"./introduction-to-advanced-manufacturing-technologies-semiconductors": [
		73395,
		3395
	],
	"./introduction-to-advanced-manufacturing-technologies-semiconductors.tsx": [
		73395,
		3395
	],
	"./islam": [
		86200,
		6200
	],
	"./islam.tsx": [
		86200,
		6200
	],
	"./judaism": [
		22793,
		2793
	],
	"./judaism.tsx": [
		22793,
		2793
	],
	"./language-pathways": [
		39425,
		9425
	],
	"./language-pathways.tsx": [
		39425,
		9425
	],
	"./latin": [
		19353,
		9353
	],
	"./latin.tsx": [
		19353,
		9353
	],
	"./law": [
		45967,
		5967
	],
	"./law.tsx": [
		45967,
		5967
	],
	"./leisure-travel-tourism": [
		45850,
		5850
	],
	"./leisure-travel-tourism.tsx": [
		45850,
		5850
	],
	"./mathematics": [
		63307,
		3307
	],
	"./mathematics.tsx": [
		63307,
		3307
	],
	"./media": [
		74192,
		4192
	],
	"./media.tsx": [
		74192,
		4192
	],
	"./medical-sci": [
		21091,
		1091
	],
	"./medical-sci.tsx": [
		21091,
		1091
	],
	"./music": [
		83973,
		3973
	],
	"./music.tsx": [
		83973,
		3973
	],
	"./pathways-to-employment": [
		76259,
		6259
	],
	"./pathways-to-employment.tsx": [
		76259,
		6259
	],
	"./pe": [
		53770,
		3770
	],
	"./pe.tsx": [
		53770,
		3770
	],
	"./performing-arts": [
		46097,
		6097
	],
	"./performing-arts.tsx": [
		46097,
		6097
	],
	"./personal-and-social-development": [
		63312,
		3312
	],
	"./personal-and-social-development.tsx": [
		63312,
		3312
	],
	"./personal-progress": [
		92345,
		2345
	],
	"./personal-progress.tsx": [
		92345,
		2345
	],
	"./philosophy-of-religion": [
		90870,
		870
	],
	"./philosophy-of-religion.tsx": [
		90870,
		870
	],
	"./physics": [
		82085,
		2085
	],
	"./physics.tsx": [
		82085,
		2085
	],
	"./preparing-for-employment": [
		77054,
		7054
	],
	"./preparing-for-employment.tsx": [
		77054,
		7054
	],
	"./preparing-for-work": [
		6287,
		6287
	],
	"./preparing-for-work.tsx": [
		6287,
		6287
	],
	"./psychology": [
		75938,
		5938
	],
	"./psychology.tsx": [
		75938,
		5938
	],
	"./rel-and-ethics": [
		37782,
		7782
	],
	"./rel-and-ethics.tsx": [
		37782,
		7782
	],
	"./religious-studies": [
		43525,
		3525
	],
	"./religious-studies.tsx": [
		43525,
		3525
	],
	"./retail-business": [
		12016,
		2016
	],
	"./retail-business.tsx": [
		12016,
		2016
	],
	"./securing-employment": [
		30328,
		328
	],
	"./securing-employment.tsx": [
		30328,
		328
	],
	"./self-development-and-wellbeing": [
		56324,
		6324
	],
	"./self-development-and-wellbeing.tsx": [
		56324,
		6324
	],
	"./sikhism": [
		66590,
		6590
	],
	"./sikhism.tsx": [
		66590,
		6590
	],
	"./sociology": [
		34992,
		4992
	],
	"./sociology.tsx": [
		34992,
		4992
	],
	"./spanish": [
		48178,
		8178
	],
	"./spanish.tsx": [
		48178,
		8178
	],
	"./sport": [
		19058,
		9058
	],
	"./sport-and-coaching-principles": [
		88057,
		8057
	],
	"./sport-and-coaching-principles.tsx": [
		88057,
		8057
	],
	"./sport.tsx": [
		19058,
		9058
	],
	"./sustainability": [
		22941,
		2941
	],
	"./sustainability.tsx": [
		22941,
		2941
	],
	"./travel": [
		12702,
		2702
	],
	"./travel.tsx": [
		12702,
		2702
	],
	"./wellbeing": [
		730,
		730
	],
	"./wellbeing.tsx": [
		730,
		730
	],
	"./welsh": [
		45775,
		5775
	],
	"./welsh-language": [
		8778,
		8778
	],
	"./welsh-language-and-literature": [
		4872,
		4872
	],
	"./welsh-language-and-literature.tsx": [
		4872,
		4872
	],
	"./welsh-language.tsx": [
		8778,
		8778
	],
	"./welsh-literature": [
		68833,
		8833
	],
	"./welsh-literature.tsx": [
		68833,
		8833
	],
	"./welsh-second-language": [
		31344,
		1344
	],
	"./welsh-second-language.tsx": [
		31344,
		1344
	],
	"./welsh.tsx": [
		45775,
		5775
	],
	"./work-welsh": [
		42726,
		2726
	],
	"./work-welsh.tsx": [
		42726,
		2726
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 65811;
module.exports = webpackAsyncContext;